//authAPI.js

import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../BaseURL/baseURL";
import { toast } from "react-toastify";

export async function checkUser(loginInfo) {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/Auth/LoginCheck_username`,
      {
        username: loginInfo.email,
        password: loginInfo.password,
      },
      {
        withCredentials: true, // ⬅️ Needed to receive the refresh token as cookie
      }
    );

    if (
      response.status === 200 &&
      response.data.message === "Login successful"
    ) {
      const { email, token } = response.data;

      return {
        email: email,
        token: token,
      };
    } else {
      throw new Error("Login failed");
    }
  } catch (error) {
    throw error;
  }
}

export function checkUserMobile(mobile) {
  // return new Promise(async (resolve, reject) => {
  //   try {
  //     debugger;
  //     const response = await axios.post(
  //       `${API_BASE_URL}/Auth/Check_User_Mobile?mobileNo=${encodeURIComponent(
  //         mobile
  //       )}`
  //     );
  //     debugger;
  //     console.log(response);
  //     if (response.status === 200) {
  //       toast.success("Otp sent successfully");
  //       console.log(response.data);
  //       const { otp, mobileNo, email } = response.data;
  //       const parsedOtp = JSON.parse(otp).result; // Parse the OTP from the string
  //       console.log(parsedOtp);
  //       resolve({
  //         otp: String(parsedOtp),
  //         email: email,
  //         phoneNumber: mobileNo,
  //         status: response.status, // Example status
  //         message: response.data.message, // Example message
  //       });
  //     } else {
  //       reject({ message: "Login failed" });
  //       toast.error("Failed to send otp");
  //       console.log(response);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Error Sending Otp");
  //     reject(error.response.data.message);
  //   }
  // });

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Auth/Check_User_Mobile?mobileNo=${encodeURIComponent(
          mobile
        )}`
      );

      console.log(response);
      if (response.status === 200) {
        toast.success("Otp sent successfully");
        console.log(response.data);
        const { otp, mobileNo, email } = response.data;
        const parsedOtp = JSON.parse(otp).result; // Parse the OTP from the string
        console.log(parsedOtp);
        resolve({
          otp: otp,
          email: email,
          phoneNumber: mobileNo,
          status: response.status, // Example status
          message: response.data.message, // Example message
        });
      } else {
        reject({ message: "Login failed" });
        toast.error("Failed to send otp");
        console.log(response);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error Sending Otp");
      reject(error.response.data.message);
    }
  });
}

// authAPI.js
export async function loginWithMobile({ mobile, otp }) {
  const resp = await axios.post(
    `${API_BASE_URL}/Auth/LoginCheck_mobile`,
    { mobileNo: mobile, otp },
    { withCredentials: true }
  );
  if (resp.status === 200 && resp.data.message === "Login successful") {
    return {
      mobile: resp.data.mobileNo,
      email: resp.data.email,
      token: resp.data.token,
    };
  } else {
    throw new Error(resp.data.message || "Login failed");
  }
}

// export function checkMobileDetail(mobileNo) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const response = await axios.post(
//         `${API_BASE_URL}/Auth/Check_User_Mobile?mobileNo=${mobileNo}`
//       );
//       if (response.status === 200) {
//         toast.success("Otp sent successfully");
//         console.log(response.data);
//         const { otp, mobileNo, email } = response.data;
//         const parsedMobileOtp = JSON.parse(otp).result; // Parse the OTP from the string
//         console.log(parsedMobileOtp);
//         console.log(mobileNo);
//         resolve({
//           mobileOtp: otp,
//           mobileNo: mobileNo,
//           email: email,
//         });
//       } else {
//         toast.error("Failed to send otp");
//         reject({ message: "Mobile Verification failed" });
//       }
//     } catch (error) {
//       toast.error("Error Sending Otp");
//       console.log(error);
//       reject(error);
//     }
//   });
// }

export async function checkMobileDetail(mobileNo, skipOtp = false) {
  const url =
    `${API_BASE_URL}/Auth/Check_User_Mobile` +
    `?mobileNo=${encodeURIComponent(mobileNo)}` +
    `&skipOtp=${skipOtp}`;
  debugger;
  try {
    const response = await axios.post(url);

    if (response.status === 200) {
      // Only show OTP‐sent toast when we actually generate one
      if (!skipOtp) {
        toast.success("OTP sent successfully");
      }

      console.log("checkMobileDetail response:", response.data);
      const {
        otp, // might be undefined when skipOtp=true
        mobileNo: returnedMobileNo,
        email,
      } = response.data;

      // parse only when otp exists
      const mobileOtp = !skipOtp && otp ? otp : null;

      console.log("parsed mobileOtp:", mobileOtp);
      console.log("canonical mobileNo:", returnedMobileNo);

      return {
        mobileOtp,
        mobileNo: returnedMobileNo,
        email,
      };
    } else {
      debugger;
      // Bad HTTP status
      const msg = skipOtp ? "Failed to verify mobile" : "Failed to send OTP";
      toast.error(msg);
      throw new Error("Mobile verification failed");
    }
  } catch (error) {
    // Network or unexpected errors
    const errMsg = skipOtp ? "Error verifying mobile" : "Error sending OTP";
    toast.error(errMsg);
    console.error(error);
    throw error;
  }
}

export function verifyOTP(otp) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Auth/VerifyOTP?otp=${encodeURIComponent(otp)}`
      );
      if (response.status === 200 && response.data.message === "OTP verified") {
        resolve(response.data);
      } else {
        reject({ message: "OTP verification failed" });
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

export function checkEmail(email) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Auth/Virtual_CheckEmail?email=${encodeURIComponent(
          email
        )}`
      );
      if (response.status === 200 && response.data.exists === false) {
        // Adjust the condition based on your actual response structure
        resolve(response.data);
        console.log(response.data);
      } else {
        reject({ message: "Email check failed" });
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

export function checkMobile(mobile) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Auth/Virtual_CheckMobile?mobile=${encodeURIComponent(
          mobile
        )}`
      );
      if (response.status === 200 && response.data.exists === false) {
        toast.success("Otp sent successfully on registered mobile no.");
        // Adjust the condition based on your actual response structure
        resolve(response.data);
      } else {
        reject({ message: "Mobile check failed" });
        toast.error("Failed to sent otp");
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

export function createUser(userData) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(userData);
      const response = await axios.post(
        `${API_BASE_URL}/Auth/InsertUser_2`,

        JSON.stringify(userData),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.statusCode === "200") {
        // Adjust the condition based on your actual response structure
        resolve(response);
        console.log(response);
      } else {
        reject({ message: "User creation failed" });
      }
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

export async function fetchStateData() {
  const response = await axios.get(`${API_BASE_URL}/Master/getStateMaster`);
  return response.data;
}

export async function fetchIdProofData() {
  const response = await axios.get(`${API_BASE_URL}/Master/IdProof`);
  return response.data;
}

export async function fetchDistrictData(stateId) {
  const response = await axios.get(
    `${API_BASE_URL}/Master/getDistrictMaster?StateID=${stateId}`
  );
  return response.data;
}
